import { render, staticRenderFns } from "./ReportRequirements.vue?vue&type=template&id=2f7c980b&scoped=true&"
import script from "./ReportRequirements.vue?vue&type=script&lang=js&"
export * from "./ReportRequirements.vue?vue&type=script&lang=js&"
import style0 from "./ReportRequirements.vue?vue&type=style&index=0&id=2f7c980b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7c980b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
